"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RoRo API
 * This documents RoRo APIs for handling public facing App needs
 *
 * The version of the OpenAPI document: 0.0.43
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var RideApi = (function (_super) {
    __extends(RideApi, _super);
    function RideApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * cancels given reservation
     */
    RideApi.prototype.cancelReservationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rideId === null || requestParameters.rideId === undefined) {
                            throw new runtime.RequiredError('rideId', 'Required parameter requestParameters.rideId was null or undefined when calling cancelReservation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/vehicles/reservation/{rideId}".replace("{" + "rideId" + "}", encodeURIComponent(String(requestParameters.rideId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RideDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * cancels given reservation
     */
    RideApi.prototype.cancelReservation = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelReservationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * current status of currently authorized user
     */
    RideApi.prototype.fetchMeRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/me",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.MeDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * current status of currently authorized user
     */
    RideApi.prototype.fetchMe = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchMeRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * finish ride
     */
    RideApi.prototype.finishRideRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rideId === null || requestParameters.rideId === undefined) {
                            throw new runtime.RequiredError('rideId', 'Required parameter requestParameters.rideId was null or undefined when calling finishRide.');
                        }
                        if (requestParameters.finished === null || requestParameters.finished === undefined) {
                            throw new runtime.RequiredError('finished', 'Required parameter requestParameters.finished was null or undefined when calling finishRide.');
                        }
                        queryParameters = {};
                        if (requestParameters.finished !== undefined) {
                            queryParameters['finished'] = requestParameters.finished;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/rides/{rideId}".replace("{" + "rideId" + "}", encodeURIComponent(String(requestParameters.rideId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RideDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * finish ride
     */
    RideApi.prototype.finishRide = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.finishRideRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * fetch billing details of a ride
     */
    RideApi.prototype.getBillingRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.billingId === null || requestParameters.billingId === undefined) {
                            throw new runtime.RequiredError('billingId', 'Required parameter requestParameters.billingId was null or undefined when calling getBilling.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/billings/{billingId}".replace("{" + "billingId" + "}", encodeURIComponent(String(requestParameters.billingId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.BillingDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * fetch billing details of a ride
     */
    RideApi.prototype.getBilling = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBillingRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * fetch ride detail
     */
    RideApi.prototype.getFullRideDetailRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rideId === null || requestParameters.rideId === undefined) {
                            throw new runtime.RequiredError('rideId', 'Required parameter requestParameters.rideId was null or undefined when calling getFullRideDetail.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/rides/{rideId}/detail".replace("{" + "rideId" + "}", encodeURIComponent(String(requestParameters.rideId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.FullRideDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * fetch ride detail
     */
    RideApi.prototype.getFullRideDetail = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFullRideDetailRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * fetch ride detail
     */
    RideApi.prototype.getRideRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rideId === null || requestParameters.rideId === undefined) {
                            throw new runtime.RequiredError('rideId', 'Required parameter requestParameters.rideId was null or undefined when calling getRide.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/rides/{rideId}".replace("{" + "rideId" + "}", encodeURIComponent(String(requestParameters.rideId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RideDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * fetch ride detail
     */
    RideApi.prototype.getRide = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRideRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * fetch user rides summary
     */
    RideApi.prototype.getUserRidesSummaryRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/rides/user-summary",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserRidesSummaryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * fetch user rides summary
     */
    RideApi.prototype.getUserRidesSummary = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUserRidesSummaryRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * get vehicle details
     */
    RideApi.prototype.getVehicleRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.vehicleId === null || requestParameters.vehicleId === undefined) {
                            throw new runtime.RequiredError('vehicleId', 'Required parameter requestParameters.vehicleId was null or undefined when calling getVehicle.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/vehicle/{vehicleId}".replace("{" + "vehicleId" + "}", encodeURIComponent(String(requestParameters.vehicleId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.VehicleFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * get vehicle details
     */
    RideApi.prototype.getVehicle = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVehicleRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * list current user rides
     */
    RideApi.prototype.listRidesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/rides/",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.BriefRideDetailPageFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * list current user rides
     */
    RideApi.prototype.listRides = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRidesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List nearby vehicles
     */
    RideApi.prototype.nearbyVehiclesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.lat === null || requestParameters.lat === undefined) {
                            throw new runtime.RequiredError('lat', 'Required parameter requestParameters.lat was null or undefined when calling nearbyVehicles.');
                        }
                        if (requestParameters.lon === null || requestParameters.lon === undefined) {
                            throw new runtime.RequiredError('lon', 'Required parameter requestParameters.lon was null or undefined when calling nearbyVehicles.');
                        }
                        queryParameters = {};
                        if (requestParameters.lat !== undefined) {
                            queryParameters['lat'] = requestParameters.lat;
                        }
                        if (requestParameters.lon !== undefined) {
                            queryParameters['lon'] = requestParameters.lon;
                        }
                        if (requestParameters.zoomLevel !== undefined) {
                            queryParameters['zoomLevel'] = requestParameters.zoomLevel;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/vehicles/",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * List nearby vehicles
     */
    RideApi.prototype.nearbyVehicles = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nearbyVehiclesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List nearby vehicles aggregated
     */
    RideApi.prototype.nearbyVehiclesAggregatedRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.lat === null || requestParameters.lat === undefined) {
                            throw new runtime.RequiredError('lat', 'Required parameter requestParameters.lat was null or undefined when calling nearbyVehiclesAggregated.');
                        }
                        if (requestParameters.lon === null || requestParameters.lon === undefined) {
                            throw new runtime.RequiredError('lon', 'Required parameter requestParameters.lon was null or undefined when calling nearbyVehiclesAggregated.');
                        }
                        queryParameters = {};
                        if (requestParameters.lat !== undefined) {
                            queryParameters['lat'] = requestParameters.lat;
                        }
                        if (requestParameters.lon !== undefined) {
                            queryParameters['lon'] = requestParameters.lon;
                        }
                        if (requestParameters.zoomLevel !== undefined) {
                            queryParameters['zoomLevel'] = requestParameters.zoomLevel;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/vehicles/aggregated/",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * List nearby vehicles aggregated
     */
    RideApi.prototype.nearbyVehiclesAggregated = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nearbyVehiclesAggregatedRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Reserve given vehicle for a set amount of time
     */
    RideApi.prototype.reserveVehicleRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling reserveVehicle.');
                        }
                        if (requestParameters.reserveSeconds === null || requestParameters.reserveSeconds === undefined) {
                            throw new runtime.RequiredError('reserveSeconds', 'Required parameter requestParameters.reserveSeconds was null or undefined when calling reserveVehicle.');
                        }
                        queryParameters = {};
                        if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                        }
                        if (requestParameters.reserveSeconds !== undefined) {
                            queryParameters['reserveSeconds'] = requestParameters.reserveSeconds;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/vehicles/reservation/",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RideDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Reserve given vehicle for a set amount of time
     */
    RideApi.prototype.reserveVehicle = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reserveVehicleRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Plays a beep sound
     */
    RideApi.prototype.rideBeepRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/beep",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Plays a beep sound
     */
    RideApi.prototype.rideBeep = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rideBeepRaw()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Plays a beep sound by anyone
     */
    RideApi.prototype.rideBeepUnconditionalRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.vehicleId === null || requestParameters.vehicleId === undefined) {
                            throw new runtime.RequiredError('vehicleId', 'Required parameter requestParameters.vehicleId was null or undefined when calling rideBeepUnconditional.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/beep/{vehicleId}".replace("{" + "vehicleId" + "}", encodeURIComponent(String(requestParameters.vehicleId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Plays a beep sound by anyone
     */
    RideApi.prototype.rideBeepUnconditional = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rideBeepUnconditionalRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * locks the current ride\'s vehicle
     */
    RideApi.prototype.rideLockRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/lock",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * locks the current ride\'s vehicle
     */
    RideApi.prototype.rideLock = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rideLockRaw()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * change scooter setting like headlights
     */
    RideApi.prototype.rideSettingRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.scooterSetting === null || requestParameters.scooterSetting === undefined) {
                            throw new runtime.RequiredError('scooterSetting', 'Required parameter requestParameters.scooterSetting was null or undefined when calling rideSetting.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/ride/setting",
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ScooterSettingToJSON(requestParameters.scooterSetting),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * change scooter setting like headlights
     */
    RideApi.prototype.rideSetting = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rideSettingRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * unlocks the current ride\'s vehicle
     */
    RideApi.prototype.rideUnlockRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/ride/unlock",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * unlocks the current ride\'s vehicle
     */
    RideApi.prototype.rideUnlock = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rideUnlockRaw()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * starting a new ride
     */
    RideApi.prototype.startRideRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.scanCode === null || requestParameters.scanCode === undefined) {
                            throw new runtime.RequiredError('scanCode', 'Required parameter requestParameters.scanCode was null or undefined when calling startRide.');
                        }
                        if (requestParameters.lat === null || requestParameters.lat === undefined) {
                            throw new runtime.RequiredError('lat', 'Required parameter requestParameters.lat was null or undefined when calling startRide.');
                        }
                        if (requestParameters.lon === null || requestParameters.lon === undefined) {
                            throw new runtime.RequiredError('lon', 'Required parameter requestParameters.lon was null or undefined when calling startRide.');
                        }
                        queryParameters = {};
                        if (requestParameters.reservationId !== undefined) {
                            queryParameters['reservationId'] = requestParameters.reservationId;
                        }
                        if (requestParameters.scanCode !== undefined) {
                            queryParameters['scanCode'] = requestParameters.scanCode;
                        }
                        if (requestParameters.lat !== undefined) {
                            queryParameters['lat'] = requestParameters.lat;
                        }
                        if (requestParameters.lon !== undefined) {
                            queryParameters['lon'] = requestParameters.lon;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/ride/rides/",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RideDetailFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * starting a new ride
     */
    RideApi.prototype.startRide = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.startRideRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return RideApi;
}(runtime.BaseAPI));
exports.RideApi = RideApi;
